import MblmCasesBorouge111x from '../../assets/img/mblm-cases-borouge-1-1@1x.png';
import ScreenShot20220422At115509Am11x from '../../assets/img/screen-shot-2022-04-22-at-11-55-09-am-1@1x.png';
import MaskGroup101x from '../../assets/img/mask-group-10@1x.png';
import MblmCasesOnecentral1Optimised1920px11x from '../../assets/img/mblm-cases-onecentral-1-optimised-1920px-1@1x.png';
import MblmCasesTechnip111x from '../../assets/img/mblm-cases-technip-1-1@1x.png';
import MblmCasesMantrac111x from '../../assets/img/mblm-cases-mantrac-1-1@1x.png';
import Path821x from '../../assets/img/path-82@1x.png';
import Image1511x from '../../assets/img/image-15-1@1x.png';
import Path761xPng1x from '../../assets/img/path-76-1x-png@1x.png';
import Path771xPng1x from '../../assets/img/path-77-1x-png@1x.png';
import Path781xPng1x from '../../assets/img/path-78-1x-png@1x.png';
import Path791xPng1x from '../../assets/img/path-79-1x-png@1x.png';
import Path801xPng1x from '../../assets/img/path-80-1x-png@1x.png';
import Path811xPng1x from '../../assets/img/path-81-1x-png@1x.png';

import Image1611x from '../../assets/img/image-16-1@1x.png';
import Image1711x from '../../assets/img/image-17-1@1x.png';
import Group12451xPng from '../../assets/img/group-1245-1x-png@1x.png';
import MantracLogo1xPng1x from '../../assets/img/mantrac-logo-1x-png@1x.png';

import './index.css';
import './responsive.css';

function StoriesSection() {
  return (
    <div className="pos_-cases-osl3uq">
      <div className="full-lenght-box-w1qUUN">
        <div className="rectangle-284-iw1yDh"></div>
      </div>


      <div className="boxed">
        <div className="presentation-os-success-stories-w1qUUN bentonsanscond-medium-black-60px">
          PresentationOS success stories
        </div>

        <div className="click-the-cards-belo-tGI4Ol bentonsanscond-light-black-26px">
          Click the cards below to learn more about the brands PresentationOS has enhanced and transformed
        </div>

        <div className="stories-card-grid">
          <div className="stories-card" onClick={() => { window.open("https://mblm.com/our-work/how-borouge-engineered-an-immersive-innovation-center-with-presentationos/") }}>
            <img className="mblm_-cases_-borouge_1-tGI4Ol" src={MblmCasesBorouge111x} />
            <div className="rectangle-310-tGI4Ol"></div>
            <img className="image-15-tGI4Ol" src={Image1511x} />
          </div>

          <div className="stories-card" onClick={() => { window.open("https://mblm.com/our-work/how-commscope-shaped-their-digital-strategy/") }}>
            <img className="screen-shot-2022-04-22-at-115509-am-tGI4Ol" src={ScreenShot20220422At115509Am11x} />
            <img className="path-82-tGI4Ol" src={Path821x} />
            <img className="image-17-tGI4Ol" src={Image1711x} />
          </div>

          <div className="stories-card" onClick={() => { window.open("https://mblm.com/our-work/how-tym-transformed-their-brand-experience/") }}>
            <img className="mask-group-10-tGI4Ol" src={MaskGroup101x} />
            <div className="rectangle-311-tGI4Ol"></div>
            
            <div className="group-1244-tGI4Ol">
              <img className="path-76-WsylTk" src={Path761xPng1x} />
              <img className="path-77-WsylTk" src={Path771xPng1x} />
              <img className="path-78-WsylTk" src={Path781xPng1x} />
              <img className="path-79-WsylTk" src={Path791xPng1x} />
              <img className="path-80-WsylTk" src={Path801xPng1x} />
              <img className="path-81-WsylTk" src={Path811xPng1x} />
            </div>
          </div>

          <div className="stories-card" onClick={() => { window.open("https://mblm.com/our-work/how-one-central-was-activated-to-become-dubais-premier-business-district/") }}>
            <img className="mblm_-cases_-one-cen-tGI4Ol" src={MblmCasesOnecentral1Optimised1920px11x} />
            <div className="rectangle-314-tGI4Ol"></div>

            <div className="group-1246-tGI4Ol">
              <img className="group-1245-wzoamO" src={Group12451xPng} />
            </div>
          </div>

          <div className="stories-card" onClick={() => { window.open("https://mblm.com/our-work/how-technipfmc-revolutionized-sales-conversations/") }}>
            <img className="mblm_-cases_-technip_1-tGI4Ol" src={MblmCasesTechnip111x} />
            <div className="rectangle-312-tGI4Ol"></div>
            <img className="image-16-tGI4Ol" src={Image1611x} />
          </div>

          <div className="stories-card" onClick={() => { window.open("https://mblm.com/our-work/how-mantrac-group-conquered-various-sales-territories-with-a-singular-digital-platform/") }}>
            <img className="mblm_-cases_-mantrac_1-tGI4Ol" src={MblmCasesMantrac111x} />
            <img className="path-91-tGI4Ol" src={Path821x} />

            <div className="logo-tGI4Ol">
              <div className="desktop-hd-copy-5-jJEUMv">
                <div className="logo-mantrac-pPxaYO">
                  <div className="rectangle-gxYLAk border-2px-white"></div>
                  <img className="mantrac-logo-gxYLAk" src={MantracLogo1xPng1x} />
                </div>
              </div>
            </div>
          </div>
        </div>

      </div>
    </div>
  );
}

export default StoriesSection;